import React, {Component} from 'react';
import StaticVideoFunctions from "../../utils/StaticVideoFunctions";
import TableContainer from "../../utils/TableContainer";
import PropTypes from "prop-types";
import Timeformat from "../../utils/Timeformat";

class SoftwareVideoTable extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
    };

    constructor(props) {

        super(props);

        this.state = {};

        this.translate = this.props.baseData.translate;
        this.userLanguage = this.props.baseData.userData.language;
        this.timeFormats = this.props.baseData.languages.getFormatByLanguage(this.userLanguage);

        this.getOnClickFunction = this.getOnClickFunction.bind(this);
        this.defaultClicked = this.defaultClicked.bind(this);

    }

    getOnClickFunction(videoId, videoDisabled) {

        if (videoDisabled !== 'true') {
            return this.props.onClick(videoId);
        } else {
            return this.defaultClicked(videoId);
        }

    }

    defaultClicked(videoId) {

        alert(this.translate('videoNotAvailable!'));

        return null;

    }

    getTableColumns() {

        return [
            {
                key : 'img',
                nameKey: 'image',
            },
            {
                key : 'title',
                nameKey: 'name',
                sortType: 'string',
            },
            {
                key : 'source',
                nameKey: 'source',
                sortType: 'string',
            },
            {
                key : 'published',
                nameKey: 'published',
                sortType: 'datetime',
            },
            {
                key : 'length',
                nameKey: 'length',
                sortType: 'string',
            },
            /*{
                key : 'views',
                nameKey: 'views',
                classes: 'text-right',
                sortType: 'int',
            },
            {
                key : 'likes',
                nameKey: 'likes',
                classes: 'text-right',
                sortType: 'int',
            },*/
        ];

    }

    getTableRows() {

        const timezone = this.props.baseData.companies.currentCompany.timezone;
        const data = this.props.videoList;
        const rows = [];

        for (let i = 0; i < data.length; i++) {
            let rowTemp = data[i];
            let published = (rowTemp.video_published) ? Timeformat.fromUnix(rowTemp.video_published).getFormatedDate(this.timeFormats.datetime, timezone) : '-';

            rows.push({
                id: rowTemp.video_id,
                img: <img src={StaticVideoFunctions.getVideoImageUrl(rowTemp.video_id, this.props.source)} alt=""/>,
                title: (rowTemp.video_title) ? rowTemp.video_title : rowTemp.video_id,
                source: this.props.source,
                published: published,
                length: rowTemp.video_length,
                views: rowTemp.video_views,
                likes: rowTemp.video_likes,
            });
        }

        return rows;

    }

    render() {

        if (this.props.videoList.length > 0) {
            const tableColumns = this.getTableColumns();
            const tableRows = this.getTableRows();

            return (
                <TableContainer
                    baseData={this.props.baseData}
                    columns={tableColumns}
                    rows={tableRows}
                    onClick={this.getOnClickFunction}
                />
            );
        }

        return this.translate('noVideosFound');

    }

}

export default SoftwareVideoTable;
